// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__3qRMA","btnLearnersbucket":"Pagination_btnLearnersbucket__8ysj-"};